import {createAction, createSlice} from "@reduxjs/toolkit";

const initialState = {
    galeryReport:{
        isPending: false,
        error: null,
        reportFile: null,
    }
}


const slice = createSlice({
    name: 'extra',
    initialState,
    reducers:{
        clearGalleryReport:(state,{payload})=>{
            state.galeryReport.reportFile = null;
            state.galeryReport.error = null;
            state.galeryReport.isPending = false;
        },
        fetchGalleryReport:(state,{payload})=>{
            state.galeryReport.reportFile = null;
            state.galeryReport.error = null;
            state.galeryReport.isPending = true;
        },
        fetchGalleryReportSuccess:(state,{payload})=>{
            state.galeryReport.reportFile = payload;
            state.galeryReport.isPending = false;
        },
        fetchGalleryReportFailure:(state,{payload})=>{
            state.galeryReport.reportFile = null;
            state.galeryReport.error = payload;
            state.galeryReport.isPending = false;
        },
    }
});
export const extraActions={
    clearGalleryReport: createAction("extra/clearGalleryReport"),
    fetchGalleryReport: createAction("extra/fetchGalleryReport"),
    fetchGalleryReportSuccess: createAction("extra/fetchGalleryReportSuccess"),
    fetchGalleryReportFailure: createAction("extra/fetchGalleryReportFailure"),

}


export default slice.reducer;